module.exports = __webpack_public_path__ + "static/img/avatar-s-3.a718f09a.png";